import { useContext, useEffect, useRef } from "react";
import { uniqueId } from "lodash";
import { GlobalModalContext } from "src/utils/GlobalModal/GlobalModalContext";

/**
 * The global modal stores its `actions` as a plain snapshot taken when
 * `setModal` is called, so a `disabled: isPending` passed at that moment never
 * updates. This hook returns an id to put on the modal and keeps the actions of
 * that modal (and only that one) disabled while `isPending` is true.
 */
export const useModalActionsPending = (isPending: boolean) => {
  const { setModal } = useContext(GlobalModalContext);
  const modalIdRef = useRef(uniqueId("absence-request-modal-"));

  useEffect(() => {
    setModal((prev) => {
      if (prev.id !== modalIdRef.current || !prev.open || !prev.actions) {
        return prev;
      }

      return {
        ...prev,
        disableOutsideClick: isPending,
        disableExitButton: isPending,
        actions: prev.actions.map((action) => ({
          ...action,
          disabled: isPending,
        })),
      };
    });
  }, [isPending, setModal]);

  return modalIdRef.current;
};
